import script from "./delete-motion-modal.vue?vue&type=script&lang=js"
export * from "./delete-motion-modal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__